import http from './http'
import type { UsageCursor, UsageFilter, UsagePage } from '@/types/api'

function instant(day: string, nextDay: boolean): string | undefined {
  if (!day) return undefined
  const parsed = new Date(`${day}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) return undefined
  if (nextDay) parsed.setDate(parsed.getDate() + 1)
  return parsed.toISOString()
}

function toParams(filter: UsageFilter): Record<string, string | undefined> {
  return {
    from: instant(filter.start, false),
    to: instant(filter.end, true),
  }
}

export const usageService = {
  async list(filter: UsageFilter, cursor: UsageCursor | null): Promise<UsagePage> {
    const { data } = await http.get<UsagePage>('/jobs/history', {
      params: { ...toParams(filter), ...(cursor ?? {}) },
    })
    return data
  },

  async exportXlsx(filter: UsageFilter): Promise<Blob> {
    const { data } = await http.get<Blob>('/jobs/history/export', {
      params: toParams(filter),
      responseType: 'blob',
    })
    return data
  },
}
